import { useCallback, useMemo } from 'react';

import {
  useDeleteFilterMutation,
  useSaveFilterMutation,
  useSavedFiltersQuery
} from '@/features/catalog/api/savedFilters';

import type { SavedFilterCriteria } from '@/entities/saved-filter';

import { buildSavedFilter, sortSavedFiltersByNewest } from '../lib/savedFilters';

export function useSavedFilters() {
  const { data, isSuccess: isLoaded } = useSavedFiltersQuery();
  const saveFilterMutation = useSaveFilterMutation();
  const deleteFilterMutation = useDeleteFilterMutation();

  const savedFilters = useMemo(() => sortSavedFiltersByNewest(data ?? []), [data]);

  const saveCurrentFilter = useCallback(
    (name: string, criteria: SavedFilterCriteria) => {
      saveFilterMutation.mutate(buildSavedFilter(name, criteria));
    },
    [saveFilterMutation]
  );

  const deleteFilter = useCallback(
    (id: string) => {
      deleteFilterMutation.mutate(id);
    },
    [deleteFilterMutation]
  );

  return {
    savedFilters,
    isLoaded,
    saveCurrentFilter,
    deleteFilter
  };
}
